var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useMemo, useCallback, useContext } from 'react';
import { useRouter } from 'next/router';
import Cookies from 'js-cookie';
import { useBreakpoint } from '../../util';
import SelectTile from '../Product/components/SelectTile/SelectTile';
import * as Styled from './ProductCardWithQuickAdd.styled';
import useOutsideClick from './ProductCard.utils';
import { useQuickAddModal } from '../QuickAddModal/QuickAddModal.context';
import { ContainerQueryContext } from '../../util/ContainerQuery.context';
import { handleNavigate } from '../../util/util';
/**
 * `ProductCardWithQuickAdd` displays a ProductCard with QuickAdd functionality.
 */
var ProductCardWithQuickAdd = function (_a) {
    var _b, _c, _d, _e;
    var badge = _a.badge, colors = _a.colors, defaultColorId = _a.defaultColorId, sizes = _a.sizes, id = _a.id, shopifyId = _a.shopifyId, onClick = _a.onClick, title = _a.title, url = _a.url, itemCount = _a.itemCount, variants = _a.variants, packDiscountCopy = _a.packDiscountCopy, _f = _a.productCardImageTestVariation, productCardImageTestVariation = _f === void 0 ? 'control' : _f, productCardPosition = _a.productCardPosition, callouts = _a.callouts, dataLabel = _a.dataLabel;
    var router = useRouter();
    var _g = useState(false), forceEmbossShadow = _g[0], setForceEmbossShadow = _g[1];
    var _h = useState(false), showSizeOptions = _h[0], setShowSizeOptions = _h[1];
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    var _j = useState((defaultColorId && colors.find(function (c) { return c.id === defaultColorId; })) || colors[0]), selectedColor = _j[0], setSelectedColor = _j[1];
    var currentColorVariants = selectedColor
        ? variants.filter(function (v) { var _a; return selectedColor.id === ((_a = v.color) === null || _a === void 0 ? void 0 : _a.id); })
        : variants;
    var usableNetEnabled = Boolean(Cookies.get('UsableNetAssistive'));
    var large = useBreakpoint().large;
    var currentColorSizes = useMemo(function () {
        var _a;
        return (_a = sizes[0]) === null || _a === void 0 ? void 0 : _a.options.map(function (option) {
            var _a;
            var matchingVariant = currentColorVariants.find(function (variant) { var _a, _b; return ((_b = (_a = variant.sizes) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.id) === option.id; });
            if (matchingVariant) {
                return __assign(__assign({}, option), { available: matchingVariant.available, variantId: (_a = matchingVariant.externalSystems) === null || _a === void 0 ? void 0 : _a.shopify });
            }
            return undefined;
        }).filter(function (x) { return Boolean(x); });
    }, [selectedColor]);
    var currentColorCategory = (_b = currentColorVariants.find(function (v) { return v.categories; })) === null || _b === void 0 ? void 0 : _b.categories;
    var currentColorPrice = (_c = currentColorVariants.find(function (v) { return v.price; })) === null || _c === void 0 ? void 0 : _c.price;
    var pdpLink = "".concat(url).concat(selectedColor ? "?variant=".concat(selectedColor.id) : '');
    var isPack = itemCount > 1;
    var ref = useOutsideClick(function () {
        setForceEmbossShadow(false);
        setShowSizeOptions(false);
    });
    var handleOpen = useQuickAddModal().handleOpen;
    var openQuickAddModal = useCallback(function () {
        var _a;
        handleOpen({
            title: title,
            subtitle: (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.title) || '',
            image: "https:".concat((_a = currentColorVariants[0]) === null || _a === void 0 ? void 0 : _a.images[0].image.file.url),
            currentColorSizes: currentColorSizes,
            currentColorCategory: currentColorCategory,
            itemCount: itemCount,
            pdpLink: pdpLink,
            shopifyId: shopifyId,
            productCardPosition: productCardPosition
        });
    }, [
        currentColorPrice,
        currentColorCategory,
        currentColorSizes,
        itemCount,
        title,
        currentColorVariants
    ]);
    var handleCardClick = function (e) {
        if (onClick) {
            onClick(e);
        }
        else {
            e.preventDefault();
            var targetUrl = e.currentTarget.getAttribute('href');
            if (targetUrl)
                handleNavigate(router, targetUrl);
        }
    };
    return (React.createElement(Styled.Emboss, { forceEmbossShadow: forceEmbossShadow, "$usableNetEnabled": usableNetEnabled, "$styleQueryMode": styleQueryMode },
        React.createElement(Styled.ProductCard, { id: id, shopifyId: shopifyId, dataLabel: dataLabel, colors: colors, images: (_e = (_d = currentColorVariants[0]) === null || _d === void 0 ? void 0 : _d.images) === null || _e === void 0 ? void 0 : _e.map(function (image) { return ({
                id: image.id,
                alt: image.title,
                src: "https:".concat(image.image.file.url)
            }); }), price: currentColorPrice, packDiscountCopy: packDiscountCopy, productCardImageTestVariation: productCardImageTestVariation, callouts: callouts, url: url, title: title, badge: (defaultColorId === (selectedColor === null || selectedColor === void 0 ? void 0 : selectedColor.id) && badge) || undefined, forceOverflowEmbossShadow: forceEmbossShadow, onClick: handleCardClick, currentColor: selectedColor, onSwatchChange: function (e) {
                return setSelectedColor(colors.find(function (c) { return c.id === e.target.value; }));
            }, clickOutsideRef: ref, productCardPosition: productCardPosition, "$usableNetEnabled": usableNetEnabled, "$styleQueryMode": styleQueryMode, onMouseEnter: function () { return large && setShowSizeOptions(true); }, onMouseLeave: function () { return large && setShowSizeOptions(false); }, renderBottomButton: sizes.length > 1 || !(currentColorSizes === null || currentColorSizes === void 0 ? void 0 : currentColorSizes.length)
                ? undefined
                : function () { return (React.createElement(Styled.QuickAdd, { link: pdpLink, setForceEmbossShadow: setForceEmbossShadow, showSizeOptions: showSizeOptions, setShowSizeOptions: setShowSizeOptions, openQuickAddModal: openQuickAddModal, "$usableNetEnabled": usableNetEnabled, productId: shopifyId }, currentColorSizes === null || currentColorSizes === void 0 ? void 0 : currentColorSizes.map(function (currentColorSize) { return (
                // @ts-ignore-next-line
                React.createElement(SelectTile, { id: currentColorSize.variantId, value: currentColorSize.value, key: currentColorSize.id, disabled: !currentColorSize.available, isUnavailable: !currentColorSize.available, note: currentColorSize.guidance || '', isPack: isPack, packSize: itemCount, category: currentColorCategory, dataLabel: "productCard_quickAdd_L2", type: "button" })); }))); } })));
};
export default ProductCardWithQuickAdd;
